import {AbstractResource} from "./abstract-resource";

export class BasicResource extends AbstractResource{
  private readonly name: string;

  constructor(id: string, resourceURl: string, name: string) {
    super(id, resourceURl);
    this.name = name
  }

  getName(): string {
      return this.name
  }
}
